
import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
    import SetTableColumns from "@/components/SetTableColumns.vue";
    import {IPage} from "@/js/page";
    import {authorizeCertApi, dictApi} from "@/api/organization";
    import {Param} from "@/js/ParamList";
    import {agingStateList} from "@/js/checkType";
    const {regionData, CodeToText} = require("@/js/region/region");
    import TableShowRangeHead from "@/components/table-show-range-head.vue";
    import TableShowRangeBody from "@/components/table-show-range-body.vue";
    import baseUrl from "@/constants";
import TableShowRangeBodyEjian from "@/components/table-show-range-body-ejian.vue";
    @Component({
        name: 'cert-list-v2',
        components: {TableShowRangeBodyEjian, SetTableColumns, TableShowRangeHead, TableShowRangeBody}
    })
    export default class CertListV2 extends Vue {
        @Prop()
        propQuery: any;

        @Prop()
        tableHeight: any;

        mode = ""; //This_Unit 本单位， This_Area 本区域， Examine 审核，Share 共享
        modeValue = "";//ALL 所有,CUR 当前,HIS 历史
        orgId = "";
        modeType = "AuthorizeCert"; //AuthorizeCert：授权证书 AllItem 全部项目 JianDing 授权检定项目 XiaoZhun 授权校准/检测项目 ShangPinLiang 商品量授权校准/检测项目 ShareAuthorizeCert 已共享授权证书
        CodeToText = CodeToText;
        regionData = regionData;
        agingStateList = agingStateList; //现行状态
        authorizedAreaArr = [];
        private exportExcel: any;
        showForm = false;//查询条件隐藏展示
        load = false;//加载
        dataList = []; //数据列表
        mechanismTypeList = [];//单位类型字典
        tabCol = [];
        allSelected = [];//列表选中数据
        sysAuthorizeCertUpdate = false; //是否有审核权限
        screenHeight = document.documentElement.clientHeight; // 可见区域高度(应为body高度，可某些环境下无法获取)
        propParams = this.getPropParams();
        total = 0;
        listParam: IPage = {
            size: 50,
            current: 1,
        };
        surveyRangesDialog = {
            visible: false,
            paramList: [] as any
        }

        getPropParams() {
            return {
                status: '',// 审核状态 0:待提交 1:未审核  2:已生效  3:未通过
                shareStatus: '', //共享状态
                agingStatus: '', //时效状态
                manageStatus: '', //添加方式
                itemName: '',//项目名称
                organizationName: '', //建标单位
                legalPerson: '', //法人代表
                competentDepartName: '', //主管部门
                authorizedArea: '', //授权区域
                organizationType: '', //单位类型
                organizationRegion: '',//所在区域
                certificateNo: '',//考核证书号
                issuingAuthority: '',//发证机关
                issuedDate: '',//发证日期
                issuedDateEnd: '',//发证日期结束
                termValidity: '',//有效期
                termValidityEnd: '',//有效期结束
              biaozhun: '', // 标准（特殊指定）
            }
        }

        created() {
            this.haveRight();
            this.listOrganizationTypeName();
            this.init();
        }

        activated(){
            if (this.$route.meta && !this.$route.meta.isBack) {
                this.showForm = false;
                this.reset();
            }else{
                this.init();
            }
            this.tableClearSelect();
        }

        reset() {
            this.authorizedAreaArr = [];
            this.propParams = this.getPropParams();
            this.refresh();
        }

        handleUpdateChange(value: any) {
            let str = "";
            for(const a of value){
                str += ('"' + a + '",');
            }
            if(str.length > 0){
                str = str.slice(0,str.length-1);
            }
            this.propParams.authorizedArea = str;
            const el = this.$refs['my-authorizedArea'] as any;
            el.dropDownVisible = false;
        }

        tableClearSelect(){
            this.allSelected = [];
            let $table = this.$refs.table as HTMLFormElement;
            if($table){
                $table.clearSelection();
            }
        }

        init() {
          if (this.propQuery) {
            const q = this.propQuery;
            if (q.size) {
              this.listParam.size = Number(q.size);
              this.listParam.current = Number(q.current);
            }
            this.mode = q.mode
            this.modeValue = q.modeValue;
            if(q.modeType){
              this.modeType = q.modeType;
            }
            if (q.agingStatus) {
              this.propParams.agingStatus = q.agingStatus;
            }
            if (q.biaozhun) {
              this.propParams.biaozhun = q.biaozhun;
            }
            let orgId = q.orgId;
            if(orgId && orgId !== '0' && orgId !== ''){
              this.orgId = orgId;
            }
          } else {
            const route = this.$route;
            const q = JSON.parse(JSON.stringify(route.query));
            if (q.size) {
              this.listParam.size = Number(q.size);
              this.listParam.current = Number(q.current);
            }
            this.mode = this.$route.params.mode
            this.modeValue = this.$route.params.modeValue;
            if(this.$route.params.modeType){
              this.modeType = this.$route.params.modeType;
            }
            let orgId = this.$route.params.orgId;
            if(orgId && orgId !== '0' && orgId !== ''){
              this.orgId = orgId;
            }
          }
            this.loadData(null);
        }

        getTableColumns() {
            if (this.modeType === 'AuthorizeCert' || this.modeType === 'ShareAuthorizeCert') {
                return "AuthorizeCert";
            }else{
                return "AuthorizeCertItem";
            }
        }

        getTitle() {
            if (this.mode === 'This_Unit' && this.modeValue === 'ALL') {
                if(this.orgId){
                    return "当前单位全部授权证书";
                }else{
                    return "本单位全部授权证书";
                }
            } else if (this.mode === 'This_Unit' && this.modeValue === 'CUR') {
                return "本单位当前授权证书";
            } else if (this.mode === 'This_Unit' && this.modeValue === 'HIS') {
                return "本单位历史授权证书";
            } else if (this.mode === 'This_Area' && this.modeValue === 'ALL') {
                return "本授权区域全部证书";
            } else if (this.mode === 'This_Area' && this.modeValue === 'CUR') {
                return "本授权区域当前证书";
            } else if (this.mode === 'This_Area' && this.modeValue === 'HIS') {
                return "本授权区域历史证书";
            } else if (this.mode === 'Share') {
                return "本授权区域当前证书";
            } else {
                return "";
            }
        }

        hasBtn(mode: string) {
            if (mode === 'Add') {
                return this.mode === 'This_Unit' && this.modeType === 'AuthorizeCert' && this.modeValue === 'ALL' && this.orgId == "";
            } else if (mode === 'Excel') {
                return true;
            } else if (mode === 'Look') {
                return this.modeType == 'AuthorizeCert' || this.modeType == 'ShareAuthorizeCert';
            } else if (mode === 'Edit') {
                return (this.mode === 'This_Unit' && this.modeType === 'AuthorizeCert' && this.modeValue === 'ALL' && this.orgId == "")
                || (this.mode === 'This_Area' && this.modeType === 'AuthorizeCert' && this.modeValue === 'ALL' && this.orgId == "" && this.sysAuthorizeCertUpdate);
            } else if (mode === 'Submit') {
                return this.mode === 'This_Unit' && this.modeType === 'AuthorizeCert' && this.modeValue === 'ALL' && this.orgId == "";
            } else if (mode === 'Del') {
                return (this.mode === 'This_Unit' && this.modeType === 'AuthorizeCert' && this.modeValue === 'ALL' && this.orgId == "")
                || (this.mode === 'This_Area' && this.modeType === 'AuthorizeCert' && this.modeValue === 'ALL' && this.orgId == "" && this.sysAuthorizeCertUpdate);
            } else if (mode === 'Examine') {
                return this.mode === 'Examine' && this.modeType === 'AuthorizeCert';
            } else if (mode === 'Share') {
                return this.mode === 'Share';
            } else if (mode === 'Release') {
                return this.mode === 'Share' && this.modeType == 'AuthorizeCert';
            } else if (mode === 'Recall') {
                return this.mode === 'Share' && this.modeType == 'ShareAuthorizeCert';
            } else if(mode === 'close'){
                return this.orgId;
            } else if(mode === 'Revoke') {
                return (this.mode === 'This_Area' && this.modeType === 'AuthorizeCert' && this.modeValue === 'ALL' && this.orgId == "" && this.sysAuthorizeCertUpdate)
            }
            return false;
        }

        loadData(callback: any) {
            this.tableClearSelect();
            const route = this.$route;
            let q = JSON.parse(JSON.stringify(route.query));
            q = Object.assign(q, this.listParam);
            for (const key in q) {
                q[key] = String(q[key]);
            }
            const params = {
                mode: this.mode,
                modeValue: this.modeValue,
                orgId: this.orgId,
                ...this.listParam,
                ...this.propParams,
            } as any;
            let API = null;
            if (this.modeType == "ShareAuthorizeCert") {
                params.shareStatus = 1;
                API = authorizeCertApi.pageV2(params);
            }else if (this.modeType === 'AllItem'){
                params.itemType = null;
                API = authorizeCertApi.pageItemV2(params);
            }else if(this.modeType === 'JianDing'){
                params.itemType = 0;
                API = authorizeCertApi.pageItemV2(params);
            }else if(this.modeType === 'XiaoZhun'){
                params.itemType = 1;
                API = authorizeCertApi.pageItemV2(params);
            }else if(this.modeType === 'ShangPinLiang'){
                params.itemType = 2;
                API = authorizeCertApi.pageItemV2(params);
            }else{
                API = authorizeCertApi.pageV2(params);
            }
            this.load = true;
            API.then((r) => {
                if (r.data.result === 0) {
                    const rData = r.data.data.records;
                    this.total = r.data.data.total;
                    this.dataList = rData;
                    if (callback) {
                        callback();
                    }
                    this.$nextTick(() => {
                        let $table = this.$refs.table as HTMLFormElement;
                        if ($table) {
                            $table.doLayout();
                        }
                        this.load = false;
                    })
                }
            });
        }

        indexMethod(index: any) {
          return (this.listParam.current-1)*this.listParam.size+index+1;
        }

        changeTabCol(e: any) {
            this.tabCol = e;
            this.$nextTick(() => {
                let $table = this.$refs.table as HTMLFormElement;
                if ($table) {
                    $table.doLayout();
                }
            })
        }

        haveRight() {
            const right = this.$store.state.userRights;
            right.forEach((e: any) => {
                if(e.name == "授权证书审核"){
                    this.sysAuthorizeCertUpdate = true;
                }
            })
        }
        handleCommand(command: string){
            switch (command) {
                case "ORIGINAL": {
                    this.toDetail("Add");
                    break;
                }
                case 'REPLACE': {
                    this.toDetail("REPLACE_ADD");
                    break;
                }
            }
        }
        toDetail(type: string) {
            const dataArr = this.allSelected as any;
            let id = 0;
            if (['Add', 'REPLACE_ADD'].indexOf(type) === -1) {
                if (dataArr.length == 0) {
                    this.$message.error("请先勾选");
                    return;
                }
                if (type === 'Return') {
                    this.batchReturn(dataArr);
                    return;
                }
                if(type === 'Revoke'){
                    this.batchRevoke(dataArr);
                    return;
                }
                if (type === 'Release' || type == "Recall") {
                    this.batchReleaseOrRecall(dataArr, type);
                    return;
                }

                if (type == 'Del') {
                    // const data = dataArr.filter((d: any) => d.status.value === 2);
                    // if (data.length > 0) {
                    //     const names = data.flatMap((e: any) => e.name).join(",");
                    //     this.$message.error("您选择的 【" + names + "】已通过，无法进行删除！");
                    //     return;
                    // }
                    this.batchDelete(dataArr);
                    return;
                }

                if (dataArr.length > 1 && (type == 'Look' || type == 'Edit' || type == 'Examine')) {
                    this.$message.error("只能勾选一条");
                    return;
                }

                if (type == 'Submit') {
                    const data = dataArr.filter((d: any) => d.status.value === 2);
                    if (data.length > 0) {
                        const names = data.flatMap((e: any) => e.name).join(",");
                        this.$message.error("您选择的 【" + names + "】已通过，无法进行提交！");
                        return;
                    }
                    this.batchSubmit(dataArr);
                    return;
                }
                if (type == 'Edit') {
                    this.toEdit(dataArr[0], type);
                    return;
                }
                id = dataArr[0].id;
            }
            this.goDetail(type, id, 3);
        }

        goDetail(type: string, id: number, manageStatus: number) {
            const firstRouterText = this.$route.path.split("/")[1];
            let mode = 0, pageType = 0;
            if (this.mode === 'This_Unit') {
                mode = 0;
            } else if (this.mode === 'This_Area') {
                mode = 1;
            } else if (this.mode === 'Examine') {
                mode = 2;
            } else if (this.mode === 'Share') {
                mode = 1;
            }
            if (type === 'Add') {
                pageType = 0;
            } else if (type === 'Look') {
                pageType = 2;
            } else if (type === 'Examine') {
                pageType = 4;
            } else if (type === 'Edit') {
                pageType = 1;
            }else if(type === 'REPLACE_ADD'){
                pageType = 0;
                manageStatus = 5;
                this.getLastOverdueCert((lastCertId: number) => {
                    this.$router.push("/" + firstRouterText + "/cert/detail/" + pageType + "/" + mode + "/" + manageStatus + "/" + lastCertId);
                });
                return;
            }
            this.$router.push("/" + firstRouterText + "/cert/detail/" + pageType + "/" + mode + "/" + manageStatus + "/" + id);
        }
        getLastOverdueCert(callback: any){
            authorizeCertApi.getLastOverdueCert().then((r: any) => {
                if(r.data.result === 0){
                    callback(r.data.data);
                }
            });
        }
        toEdit(data: any, type: string) {
            if (data.status.value === 2 && !this.sysAuthorizeCertUpdate) {
                this.$message.error("您选择的 【" + data.name + "】已通过，无法进行编辑！");
                return;
            }
                // this.$confirm('您勾选的是审核“已通过”的授权证书，编辑并保存后需要重新提交审核，是否继续编辑？', '提示', {
                //     confirmButtonText: '是',
                //     cancelButtonText: '否',
                //     type: 'warning',
                //     dangerouslyUseHTMLString: true
                // }).then(() => {
                //     this.goDetail(type, data.id, data.manageStatus.value);
                // });
            // } else {
                this.goDetail(type, data.id, data.manageStatus.value);
            // }
        }

        batchDelete(dataArr: any){
            this.$confirm('您勾选了:  ' + dataArr.length + '条授权证书，是否删除', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                authorizeCertApi.delete({authorizeCertIds: dataArr.flatMap((e:any)=>e.id).join(",")}).then(r => {
                    if (r.data.result === 0) {
                        this.$message.success("删除成功");
                        this.loadData(null);
                    }
                })
            }).catch(() => {
                console.log("取消")
            });
        }

      batchReleaseOrRecall(dataArr: any, type: string) {
        const str = type == 'Release' ? '发布' : '撤回';
        this.$confirm('您勾选了:  ' + dataArr.length + '条授权证书，是否' + str + '？', '提示', {
          confirmButtonText: '是',
          cancelButtonText: '否',
          type: 'warning',
          dangerouslyUseHTMLString: true
        }).then(() => {
          const loading = this.$loading({
            text: `正在${str}，请等待...`,
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          });
          authorizeCertApi.updateShare(dataArr.flatMap((e: any) => e.id).join(","), (type === 'Release' ? 1 : 2)).then(r => {
            loading.close();
            if (r.data.result === 0) {
              this.$message.success(str + "成功！");
              this.loadData(null);
            }

          })
        })
      }
        batchRevoke(dataArr: any){
            this.$confirm('确定要撤销授权证书编号为:  ' + dataArr.flatMap((e: any) => e.certificateNo).join(",") + '？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                dangerouslyUseHTMLString: true
            }).then(() => {
                authorizeCertApi.updateStatus({ids: dataArr.flatMap((e: any) => e.id).join(","), status: 0, reason: '', type: 0}).then(r => {
                    if (r.data.result === 0) {
                        this.$message.success("撤销成功");
                        this.loadData(null);
                    }
                })
            }).catch(() => {
                console.log("取消")
            });
        }
        batchReturn(dataArr: any) {
            this.$confirm('您勾选了:  ' + dataArr.length + '条授权证书，是否退回？', '提示', {
                confirmButtonText: '是',
                cancelButtonText: '否',
                type: 'warning',
                dangerouslyUseHTMLString: true
            }).then(() => {
                authorizeCertApi.updateStatus({
                    ids: dataArr.flatMap((e: any) => e.id).join(","),
                    status: 0,
                    reason: '',
                    type: 0
                }).then(r => {
                    if (r.data.result === 0) {
                        this.$message.success("退回成功");
                        this.loadData(null);
                    }
                })
            })
        }

        batchSubmit(dataArr: any) {
            this.$confirm('您勾选了' + dataArr.length + '条授权证书，是否提交审核？', '提示', {
                confirmButtonText: '是',
                cancelButtonText: '否',
                type: 'warning',
                dangerouslyUseHTMLString: true
            }).then(() => {
                authorizeCertApi.updateStatus({
                    ids: dataArr.flatMap((e: any) => e.id).join(","),
                    status: 1,
                    reason: '',
                    type: 0
                }).then(r => {
                    if (r.data.result === 0) {
                        this.$message.success("提交成功");
                        this.refresh();
                    }
                })
            })
        }

        refresh() {
            this.allSelected = [];
            let $table = this.$refs.table as HTMLFormElement;
            $table.clearSelection();
            this.loadData(null);
        }

        listOrganizationTypeName() {
            dictApi.listDictItem({typeCode: "dwlb"}).then((r) => {
                if (r.data.result === 0) {
                    this.mechanismTypeList = r.data.data;
                }
            });
        }

        getOrganizationTypeName(organizationTypes: string) {
            const arr = organizationTypes ? organizationTypes.split(",") : [];
            const arr2 = [] as any;
            arr.forEach((e: any) => {
                const obj = this.mechanismTypeList.find((e2: any) => e2.dictKey === e) as any;
                if (obj) {
                    arr2.push(obj.dictValue);
                }
            })
            return arr2.length > 0 ? arr2.join("，") : "-";
        }

        pageSizeChange(val: number) {
            this.listParam.size = val;
            this.refresh();
        }

        pageCurrentChange(val: number) {
            this.listParam.current = val;
            this.loadData(null);
        }

        memberSelect(selection: any, row: any) {
            this.allSelected = selection;
        }
        onExportExcel() {
            const loading = this.$loading({
                text: '正在导出Excel',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            const listParam = JSON.parse(JSON.stringify(this.listParam));
            this.listParam.size = this.total;    //将表格长度变成数据总长度
            this.listParam.current = 1;          //显示第一页
            this.loadData(() => {
                this.exportExcel(() => {
                    this.listParam = listParam;    //表格长度还原
                    this.loadData(null);
                    loading.close();
                }, "授权证书列表.xlsx");
            });
        }
        cloneObj(jsonString: string) {
            if (jsonString) {
                return JSON.parse(jsonString);
            }
            return "";
        }
        closeSurveyRangesDialog() {
            this.surveyRangesDialog.paramList = [] as Param[];
            this.surveyRangesDialog.visible = false;
        }

        openSurveyRangesDialog(surveyRanges: string) {
          // this.surveyRangesDialog.paramList = this.parseParamList(surveyRanges);
            this.surveyRangesDialog.paramList = surveyRanges;
            this.surveyRangesDialog.visible = true;
        }

        parseParamList(jsonString: string) {
            if (jsonString) {
                return JSON.parse(jsonString);
            } else {
                return [] as Param[];
            }
        }
        down(row: any) {
            try {
                const obj = JSON.parse(row);
                if (typeof obj == 'object' && obj) {
                    window.open(baseUrl + "/file/download?file=" + obj[0].url + "&name=" + obj[0].name, '_blank');
                    return true;
                } else {
                    return false;
                }
            } catch (e) {
                window.open(baseUrl + "/file/download?file=" + row + "&name=计量授权证书", '_blank');
                return false;
            }
        }
    }
